import { gql } from '@apollo/client';

export const SignOutMutation = gql`
  mutation SignOutMutation {
    signOut {
      success
    }
  }
`;
